export const getUrlParam = (param: string, url: string) => {
  if (!url) url = location.href;
  param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regexS = '[\\?&]' + param + '=([^&#]*)';
  const regex = new RegExp(regexS);
  const results = regex.exec(url);
  return results === null ? null : results[1];
};
